import { environment as environmentFromFile } from '../environment'
import { readFromProcessEnv } from './read-from-process-env'
import { IBaseEnvironment, IEnvironment } from '../environment.types'

export const readFullEnv = (): IEnvironment => {
  const staticEnv: IBaseEnvironment = {
    REDIRECT_URL_KEY: 'cinch-account-confirm-redirectUrl',
  }

  const processEnv = readFromProcessEnv()

  return {
    ...staticEnv,
    ...environmentFromFile,
    ...processEnv,
  }
}
